import $ from 'jquery';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';

import './app.practice-form'

import './validation'

function updateSubmitButtonState() {
      if (window.termsCheckbox.is(':checked')) {
          window.submitButton.prop('disabled', false); // Enable the button
      } else {
          window.submitButton.prop('disabled', true);  // Disable the button
      }
  }
function togglePhysicalAddressFields() {
    var $deliveryAddress = $('#Postal-Address1');
    var $deliveryStreetAddress = $('#Postal-Address2');
    var $deliverySuburb = $('#Postal-Suburb');
    var $deliveryCity = $('#Postal-City');
    var $deliveryState = $('#Postal-State');
    var $deliveryPostCode = $('#Postal-PostCode');
    var $deliveryCountry = $('#Postal-Country');
    var $addressAddress = $('#Home-Address1');
    var $addressStreetAddress = $('#Home-Address2');
    var $addressSuburb = $('#Home-Suburb');
    var $addressCity = $('#Home-City');
    var $addressState = $('#Home-State');
    var $addressPostCode = $('#Home-PostCode');
    var $addressCountry = $('#Home-Country');

    var $physicalAddressFields = $('#physicalAddressFields');
    var originalPhysicalAddressValues = {
        address: $addressAddress.val(),
        streetAddress: $addressStreetAddress.val(),
        suburb: $addressSuburb.val(),
        city: $addressCity.val(),
        state: $addressState.val(),
        postCode: $addressPostCode.val(),
        country: $addressCountry.val()
    };

    if (window.isSameAddressCheckbox.is(':checked')) {
        // Copy values from Delivery to Physical
        $addressAddress.val($deliveryAddress.val());
        $addressStreetAddress.val($deliveryStreetAddress.val());
        $addressSuburb.val($deliverySuburb.val());
        $addressCity.val($deliveryCity.val());
        $addressState.val($deliveryState.val());
        $addressPostCode.val($deliveryPostCode.val());
        $addressCountry.val($deliveryCountry.val());


    } else {
        // Restore original physical address values
        $addressAddress.val('');
        $addressStreetAddress.val('');
        $addressSuburb.val('');
        $addressCity.val('');
        $addressState.val('');
        $addressPostCode.val('');
        $addressCountry.val('');

        // Enable physical address fields
        $physicalAddressFields.find('input, select, textarea').prop('disabled', false);
    }
}

function clearValidationMessages() {
  const errorContainers = document.querySelectorAll('.field-validation-error');

  errorContainers.forEach(container => {
    container.textContent = '';
    container.classList.remove('text-danger');

    const innerSpan = container.querySelector('[id$="-error"]');
    if (innerSpan) {
      innerSpan.textContent = '';
      innerSpan.classList.remove('input-validation-error');
    }
  });

  const errorInputs = document.querySelectorAll('.input-validation-error');
  errorInputs.forEach(input => {
    input.classList.remove('input-validation-error');
    input.classList.remove('is-invalid');
  });
}
const partialViewContainer = document.getElementById('form-elements-container');

function loadPartialView(selectedValue) {
    partialViewContainer.innerHTML = '';
    if (typeof window.submitButton !== 'undefined') {
        window.submitButton.hide();
    }

    if (!selectedValue) {
        return;
    }

    const url = `/umbraco/surface/JoinForm/LoadPartialLoader?selectedMembership=${selectedValue}`;

    fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'text/html'
        }
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
    })
    .then(html => {
        partialViewContainer.innerHTML = html;

        if ($(partialViewContainer).children().length > 0){
            window.submitButton = $('.js-submit-row').find("input[type='submit'], button[type='submit']");
            window.termsCheckbox = null;
            window.isSameAddressCheckbox = null;

            if(selectedValue!='FriendsOfArchitecture'){
                if ($(partialViewContainer).length > 0){
                    window.isSameAddressCheckbox = $(partialViewContainer).find('#IsAddressSameAsDelivery');
                    window.termsCheckbox = $(partialViewContainer).find('#declaration-terms-agree');
                    if(window.termsCheckbox.length > 0){
                        window.termsCheckbox.on('change', updateSubmitButtonState);

                        updateSubmitButtonState();
                    }

                    if(window.isSameAddressCheckbox.length > 0){
                        window.isSameAddressCheckbox.on('change', togglePhysicalAddressFields);
                    }

                }

                function decodeHtml(encoded) {
                    return $('<textarea/>').html(encoded ?? '').text();
                }

                function applyLink(inputSelector, linkSelector) {
                    const value = $(inputSelector).val();
                    if (value) {
                        $(linkSelector).attr("href", value);
                        $(linkSelector).attr("target", "_blank");
                    }
                }

                applyLink('#TermsAndConditionsLink', '#js-terms-and-conditions-link');
                applyLink('#PrivacyPolicyLink', '#js-privacy-policy-link');
                applyLink('#ConstitutionLink', '#js-constitution-link');
                applyLink('#TermsAndConditionsLink', '#js-terms-conditions-link-practice-form');
                applyLink('#PrivacyPolicyLink', '#js-privacy-policy-link-practice-form');

                if(selectedValue!='Practice'){
                    const encoded = $('#IndividualMemberDeclaration').val();
                    $('#js-declaration').html(decodeHtml(encoded));
                }else{
                    const encoded = $('#PracticeMemberDeclaration').val();
                    $('#js-declaration').html(decodeHtml(encoded));

                    const thankYouEncoded = $('#CMSThankYou').val();
                    $('#js-thankyou-msg').html(decodeHtml(thankYouEncoded));
                }
                const $otherInputContainer = $('#otherSchoolInputContainer');
                const $otherTextInput = $('#other-school-text');
                const $radioButtons = $('input[name="EducationDetails.SchoolOfArchitecture"]');
                const $otherRadio = $('#school-other');
                if ($radioButtons.length > 0 && $otherInputContainer.length > 0) {
                    function toggleOtherInput() {
                        if ($otherRadio.is(':checked')) {
                            $otherInputContainer.show();
                            $otherTextInput.focus();
                        } else {
                            $otherInputContainer.hide();
                            $otherTextInput.val('');
                        }
                    }
                    $radioButtons.on('change', toggleOtherInput);
                    toggleOtherInput();
                }
            }else{

                window.submitButton.prop('disabled', false);
            }

            window.submitButton.show();
            window.currentform = $('#IndividualForm');
            $.validator.unobtrusive.parse(window.currentform);
        }

    })
    .catch(error => {
        console.error('Error loading partial view:', error);
        partialViewContainer.innerHTML = '<p class="text-danger">Failed to load details.</p>';
    });
}
window.addEventListener('DOMContentLoaded', () => {
    $('#SelectedMembership').on('change', function() {
        var selected  = $(this).val();

        loadPartialView(selected);
    });

    $(document).on('blur', '.js-website-field', function() {
        // if the field is not empty and doesn't start with http:// or https://, prepend with https://
        var value = $(this).val().trim().toLowerCase();
        if (value && !value.startsWith('http://') && !value.startsWith('https://')) {
            $(this).val('https://' + value);
            $(this).trigger('focus');
            $(this).trigger('blur');
        }
    });
});
